import debounce from "@Shared/Helpers/Util/Debounce";
import supplierReducer from "@Store/Reducers/Suppliers/companies";
import { put } from "@Api/Suppliers/companies";
import sleep from "@Helpers/Sleep";
import Factory from "@Shared/Factory";
import { UPDATE_LIBRARY } from "@Store/Actions/Suppliers/companies";
import { store } from "./../../";
const updateSupplier = (supplier) => put(supplier);
const debounceTime = 1500;
class SupplierLibrariesStack {
    id;
    stack = [];
    dispatch;
    constructor(id, dispatch) {
        this.id = id;
        this.dispatch = dispatch;
    }
    addToStack(action) {
        this.stack.push(action);
        if (this.stack.length === 1) {
            this.save();
        }
    }
    save = debounce(async (updatedSupplier) => {
        const state = store.getState();
        const ids = this.stack.map((a) => a.$uuid);
        const supplier = updatedSupplier ||
            state.suppliers.companies.find((data) => data.id === this.id);
        await this._save(supplier, 5, ids);
    }, debounceTime);
    async _save(supplier, tries = 5, ids = []) {
        try {
            const updatedTender = await updateSupplier(supplier);
            this.stack = this.stack.filter((a) => !ids.includes(a.$uuid));
            if (this.stack.length > 0) {
                this.replayStack(updatedTender);
            }
            else {
                this.dispatch({
                    type: UPDATE_LIBRARY,
                    data: updatedTender,
                });
            }
        }
        catch (error) {
            if (tries < 1) {
                throw error;
            }
            if (error.response.status === 409 ||
                error.response.status === 425) {
                await sleep(250);
                await this.replayStack(error.response.data.state, tries);
            }
        }
    }
    replayStack(serverState, tries = 6) {
        let responses = [Factory.Supplier(serverState)];
        const stack = [...this.stack];
        const ids = [];
        for (const action of stack) {
            responses = supplierReducer(responses, action);
            ids.push(action.$uuid);
        }
        this._save(responses[0], tries, ids);
    }
}
const stacks = {};
export default (store) => (next) => (action) => {
    const state = next(action); // Store is updated
    const { type, data } = action;
    if (type === UPDATE_LIBRARY && data.effects !== undefined) {
        if (!stacks[data.id]) {
            stacks[data.id] = new SupplierLibrariesStack(data.id, store.dispatch);
        }
        stacks[data.id].addToStack(action);
    }
    return state;
};
